(function() {
  const dialog = document.querySelector('.bbl-email-subscription-dialog');

  function openDialog() {
    dialog.showModal();
  }

  function closeDialog() {
    dialog.close();
  }

  dialog.addEventListener('click', (e) => {
    if (e.target === dialog) {
      closeDialog();
    }
  })

  window.emailSubscription = { openDialog, closeDialog };

  // binding open class name
  const buttons = document.querySelectorAll('.bbl-email-subscription_open-dialog');
  Array.from(buttons).forEach(element => {
    element.addEventListener('click', () => {
      openDialog();
      window.setupEmailSubscription('.bbl-email-subscription-dialog');
    })
  });

  // close button
  document.querySelector('.bbl-email-subscription-dialog_close').addEventListener('click', () => {
    closeDialog();
  });

})();
